<template>
  <div class="tab-pane">
    <div class="pane-item">
      <div class="pane-item-text">
        <div class="pane-item-title">
          千尺链区块链系统软件著作权于2021年4月1日取得
        </div>
        <div class="pane-item-desc">
          &emsp;&emsp;千尺区块链系统是一种分布式系统，其在物理结构上是分布式部署的，而在逻辑形式上整体统一的。在通常的场景中，以数据的视角来看，千尺区块链系统被应用为一种能够连接多个业务参与方的分布式的消息分发、数据处理与共享平台，基于对共识协议、密码学算法和数据结构等技术的组合运用，实现了在逻辑形式上整体统一的数据账本。
        </div>
      </div>
      <img src="@/assets/about/rz1.png" />
    </div>
    <div class="pane-item">
      <div class="pane-item-text">
        <div class="pane-item-title">
          原子平台（星河低代码平台）软件著作权于2021年9月1日取得
        </div>
        <div class="pane-item-desc">
          &emsp;&emsp;原子应用平台（星河低代码平台Atomyplatform）是一个通用的应用系统基础平台框架，遵循软件架构的最佳实践、主流规范和约定俗成配置操作习惯，将开发一个应用系统所需的通用基础架构和组件整合在一起。<br />
          &emsp;&emsp;原子应用平台的目标是提供简化搭建一个企业级应用系统的复杂度，通过平台化和采用约定俗成的规则使得开发者只需要聚焦在与业务相关的业务逻辑的开发上，而与业务无关的软件通用架构和非功能性的基础组件则可以通过平台直接获得相应的功能实现以及包括可靠性、扩展性、安全性、伸缩性、可维护性等众多技术特性。
        </div>
      </div>
      <img src="@/assets/about/rz2.png" />
    </div>
    <div class="pane-item">
      <div class="pane-item-text">
        <div class="pane-item-title">链聚电商平台</div>
        <div class="pane-item-desc">
          链聚电商平台构建了一个完整的线上零售业务闭环。商家通过后台管理系统进行商品上架、定价与库存维护，并可策划各类促销活动。前端小程序商城同步展示商品与活动信息，消费者可完成选购、下单及在线支付。支付成功后，订单信息即时回传至后台，供商家进行发货等后续处理。该流程将商品管理、营销推广、交易结算与订单履约等核心环节无缝衔接，实现了高效运营。
        </div>
      </div>
      <img src="@/assets/about/emall.png" />
    </div>
    <div class="pane-item">
      <div class="pane-item-text">
        <div class="pane-item-title">数转精灵</div>
        <div class="pane-item-desc">
          “数转精灵”是一款基于移动互联网的轻量化企业服务软件著作权。该APP采用云端协同架构，前端适配主流移动操作系统，提供响应式的用户交互界面。其核心在于将传统PC端的中小企业管理系统精髓浓缩于移动端，该APP通过连接人、事、物、数，构建了轻量级的企业运营闭环，显著提升了内部协同与执行效率，实现业务数据实时同步、现场任务快速处理与多维度统计分析，以低部署成本、高操作便捷性，满足中小企业灵活的数字化管理需求。
        </div>
      </div>
      <img src="@/assets/about/app.png" />
    </div>
    <div class="pane-item">
      <div class="pane-item-text">
        <div class="pane-item-title">凤栖前端开发平台</div>
        <div class="pane-item-desc">
          凤栖前端开发平台：是一个面向交互模式设计和支持元数据的前端界面开发框架，是星河低代码平台的前端解决方案。
          FlexUE
          是一个完整意义上的企业级前端开发框架，它不属于常见的那类基于模板生成页面代码的模板工具。
          FlexUE Framework
          不仅关注控件元素的定义，而且关注交互模式的定义，最重要的是注重与后端架构的无缝集成，前端组件的交互状态内置了对领域模型、数据、服务、账户、授权等方面的支持与对接。
          FlexUE
          设计上以企业级平台核心为基础，十分注重开发应用的简单、灵活、开放和易扩展的。为满足从便捷性到完全扩展性的需要，提供
          3 种可选方式开发前端界面：(1)
          基于图形化配置工具定义界面。(2)集成后端数据模型运行时渲染界面。(3)采用
          HTML/js/css 和 Vue 等以原生语言编程定义前端界面。 FlexUE
          还内置提供了丰富的组件，包括动态表单、表格、级联树、数据引用、文件上传/下载、图片预览/缩略、数学公式等等。
          FlexUE 提供完全的扩展性，用户应用的开发者可以引入诸如 Bootstrap
          之类的第三方库，也可以引入自己的私有库。
        </div>
      </div>
      <img src="@/assets/about/flexue.png" />
    </div>
    <div class="pane-item">
      <div class="pane-item-text">
        <div class="pane-item-title">数字化综合管理平台</div>
        <div class="pane-item-desc">
          该软著以业务流程驱动为核心的企业综合管理平台。系统覆盖前端电商销售、中端生产计划与物料采购、后端仓储物流与设备能耗监控等全价值链活动。通过统一数据平台，它实现了跨部门信息无缝流转与业务高效协同，并利用集成的决策分析模块，将运营数据转化为可执行的洞察，全面提升企业资源规划与执行效率。
        </div>
      </div>
      <img src="@/assets/about/emall.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: "copyright-software",

  data() {
    return {};
  },
  created() {},
  computed: {},

  mounted() {},

  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    choose(index) {
      this.chooseIndex = index;
    },
  },
};
</script>
<style lang="less" scoped src="./copyright.less"></style>
